/* LEDPLANET lp-site.js (17-10-2026): sitewide scripts uit de ledplanet-snippets, als gecacht bestand (defer) i.p.v. inline op elke pagina.
   Geladen via snippets/ledplanet-snelheid. Teksten per taal staan nog in de snippets zelf (window.LP_ZOEK, LP_NACHT, LP_CHAT, LP_COOKIES).
   Wijzig de werking HIER. Elk onderdeel staat in een eigen try/catch, zodat een fout in het ene de rest niet stopt. */

/* ===================== uit snippets/ledplanet-landkeuze ===================== */
try {
(function () {
  // ---------- 1. levertijd-teksten op de hele site ----------
  var WOORD = /(werkdag|werktag|working day|business day|jour|d[ií]as? h[aá]bil|d[ií]as? laborable|giorn|dni|dzie)/i;
  var BEREIK = /(\d{1,2})\s?[–-]\s?(\d{1,2})(?=\s*(werkdag|Werktag|working day|business day|jours? ouvr|d[ií]as|giorni|dni))/i;
  function bereik() {
    var L = window.LP_LEVERTIJD; if (!L || !L.land) return null;
    var c = L.land(); if (!c || c === 'NL') return null;
    var ll = (L.landen && L.landen()) || [];
    for (var i = 0; i < ll.length; i++) if (ll[i].code === c) return ll[i];
    return null;
  }
  function uitgezonderd(el) { return !el || el.closest('script,style,.delivery-label-done,.delivery-label-pending,#productUSPs,.lp-bs,.lpp,.lp-tk,input,textarea,select'); }
  function pasLevertijd() {
    var b = bereik();
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT), n, lijst = [];
    while ((n = w.nextNode())) lijst.push(n);
    lijst.forEach(function (t) {
      var el = t.parentElement; if (uitgezonderd(el)) return;
      if (t.__lpOrig === undefined) {
        var v = t.nodeValue;
        if (BEREIK.test(v)) t.__lpOrig = v;
        else if (/^\s*\d{1,2}\s?[–-]\s?\d{1,2}\s*$/.test(v)) {          // los getal ("1–3") met het woord ernaast (kerncijfers)
          var buur = el.nextElementSibling || (el.parentElement && el.parentElement.nextElementSibling);
          if (buur && WOORD.test(buur.textContent || '')) { t.__lpOrig = v; t.__lpLos = true; } else return;
        } else return;
      }
      if (!b) { t.nodeValue = t.__lpOrig; return; }
      // zelfde rekensom als snippets/ledplanet-levertijd: 1–3 wordt (1+min-1)–(3+max-1)
      t.nodeValue = t.__lpOrig.replace(/(\d{1,2})(\s?[–-]\s?)(\d{1,2})/, function (m, x, sep, y) { return (+x + b.min - 1) + sep + (+y + b.max - 1); });
    });
  }

  // ---------- 1b. 'gratis verzending vanaf € 50' volgt het land (14-10-2026) ----------
  // NL/BE blijft € 50 (tekst ongemoeid), Duitsland € 100, overige landen € 150. Alleen tekst met 'gratis' + 'vanaf € 50' wordt aangepast.
  var GRATIS = /(gratis|kostenlos|free|gratuit|darmow)/i;
  var VANAF = /((?:vanaf|ab|from|d[eè]s|desde|da|od)\s*(?:€|EUR)?[\s ]*)50(?!\d)/i;
  function pasGratis() {
    var L = window.LP_LEVERTIJD, c = (L && L.land && L.land()) || 'NL';
    var d = (c === 'NL' || c === 'BE') ? 0 : (c === 'DE' ? 100 : 150);
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT), n, lijst = [];
    while ((n = w.nextNode())) lijst.push(n);
    lijst.forEach(function (t) {
      var el = t.parentElement; if (uitgezonderd(el)) return;
      if (t.__lpOrigG === undefined) {
        var v = t.nodeValue;
        if (GRATIS.test(v) && VANAF.test(v)) t.__lpOrigG = v; else return;
      }
      t.nodeValue = d ? t.__lpOrigG.replace(VANAF, function (m, p) { return p + d; }) : t.__lpOrigG;
    });
  }

  // ---------- 2. taalkeuze ----------
  var box = document.getElementById('lp-tk'); if (!box) return;
  var HUIDIG = box.dataset.huidig, TALEN = (box.dataset.talen || '').split(/\s+/), LANDEN = (box.dataset.landen || '').split(/\s+/);
  var TAAL_VAN = { NL: 'nl', BE: 'nl', DE: 'de', AT: 'de', CH: 'de', LU: 'de', LI: 'de', FR: 'fr', MC: 'fr', ES: 'es', IT: 'it', SM: 'it', PL: 'pl', PT: 'pt' };
  var T = {
    nl: ['Deze winkel is er ook in het Nederlands.', 'Verder in het Nederlands', 'Nee, bedankt'],
    de: ['Diesen Shop gibt es auch auf Deutsch.', 'Auf Deutsch weiter', 'Nein, danke'],
    en: ['This shop is also available in English.', 'Continue in English', 'No thanks'],
    fr: ['Cette boutique existe aussi en français.', 'Continuer en français', 'Non merci'],
    es: ['Esta tienda también está en español.', 'Seguir en español', 'No, gracias'],
    it: ['Questo negozio è disponibile anche in italiano.', 'Continua in italiano', 'No, grazie'],
    pl: ['Ten sklep jest dostępny także po polsku.', 'Kontynuuj po polsku', 'Nie, dziękuję'],
    pt: ['Esta loja também está disponível em português.', 'Continuar em português', 'Não, obrigado']
  };
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function codeVoor(kort) { var s = box.querySelector('#lp-tk-kies'); for (var i = 0; i < s.options.length; i++) if (s.options[i].value.slice(0, 2).toLowerCase() === kort) return s.options[i].value; return null; }
  var land = null, doel = null;
  function kiesTaal(code) {
    var f = document.getElementById('lp-tk-form'); if (!f) return;
    f.querySelector('[name=language_code]').value = code;
    if (land && LANDEN.indexOf(land) > -1) f.querySelector('[name=country_code]').value = land;
    ls('lp_tk_nee', ''); f.submit();
  }
  function sluit(onthoud) { if (onthoud && land) ls('lp_tk_nee', land); box.classList.remove('is-open'); setTimeout(function () { box.hidden = true; }, 350); }
  function bekijk() {
    var L = window.LP_LEVERTIJD; if (!L || !L.land) return;
    land = L.land();
    var kort = TAAL_VAN[land] || 'en';
    if (TALEN.indexOf(kort) < 0) kort = 'en';
    if (TALEN.indexOf(kort) < 0 || kort === HUIDIG || ls('lp_tk_nee') === land) { if (!box.hidden) sluit(false); return; }
    doel = codeVoor(kort); if (!doel) return;
    var t = T[kort] || T.en, eigen = T[HUIDIG] || T.en;
    document.getElementById('lp-tk-tekst').textContent = t[0];
    document.getElementById('lp-tk-ja').textContent = t[1];
    document.getElementById('lp-tk-nee').textContent = eigen[2];
    box.hidden = false; requestAnimationFrame(function () { box.classList.add('is-open'); });
  }
  document.getElementById('lp-tk-ja').addEventListener('click', function () { if (doel) kiesTaal(doel); });
  document.getElementById('lp-tk-nee').addEventListener('click', function () { sluit(true); });
  box.querySelector('.lp-tk__x').addEventListener('click', function () { sluit(true); });
  document.getElementById('lp-tk-kies').addEventListener('change', function (e) { if (e.target.value !== box.querySelector('#lp-tk-form [name=language_code]').value) kiesTaal(e.target.value); });

  function alles() { try { pasLevertijd(); } catch (e) {} try { pasGratis(); } catch (e) {} try { bekijk(); } catch (e) {} }
  document.addEventListener('lp:levertijd-update', function () { setTimeout(alles, 30); });
  function start() { alles(); setTimeout(alles, 1500); }   // tweede ronde: teksten die later verschijnen
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
} catch (e) { if (window.console) console.error('lp-site landkeuze', e); }

/* ===================== uit snippets/ledplanet-zoek (teksten: window.LP_ZOEK) ===================== */
try {
(function () {
  var C = window.LP_ZOEK; if (!C) return;
  var T = C.t || [];
  var URL_SUG = C.url + '.json';
  var LOC = C.loc;
  var CUR = C.cur;
  var POP = (C.pop || []).filter(Boolean);
  var geld = new Intl.NumberFormat(LOC, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); /* prijs zonder valutateken, net als de rest van de winkel */
  var ic = {
    zoek: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>',
    klok: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    map: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M3 7h6l2 2h10v10H3z"/></svg>',
    pijl: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>'
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function markeer(tekst, q) {
    var h = esc(tekst);
    q.split(/\s+/).filter(function (w) { return w.length > 1; }).forEach(function (w) {
      var re = new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
      h = h.replace(re, '<mark>$1</mark>');
    });
    return h;
  }
  function recent() { try { return JSON.parse(localStorage.getItem('lp_zoek_recent') || '[]'); } catch (e) { return []; } }
  function bewaar(q) {
    q = (q || '').trim(); if (q.length < 2) return;
    try { var r = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); r.unshift(q); localStorage.setItem('lp_zoek_recent', JSON.stringify(r.slice(0, 6))); } catch (e) {}
  }

  // Gloed en lichtbundel van de homepage-hero in een eigen laag, zodat de hero het paneel niet afknipt
  var hero = document.querySelector('.lph-hero');
  if (hero && !hero.querySelector('.lph-hero__deco')) {
    var deco = document.createElement('div'); deco.className = 'lph-hero__deco';
    hero.querySelectorAll('.lph-hero__gloed, .lph-hero__bundel').forEach(function (el) { deco.appendChild(el); });
    hero.insertBefore(deco, hero.firstChild);
  }

  var teller = 0;
  function koppel(input) {
    var form = input.closest('form');
    if (!form || form.dataset.lpZoek) return;
    form.dataset.lpZoek = '1';
    var actie = form.getAttribute('action') || '/search';
    var id = 'lph-sug-' + (++teller);
    var paneel = document.createElement('div');
    paneel.className = 'lph-sug'; paneel.id = id; paneel.hidden = true; paneel.setAttribute('role', 'listbox');
    form.classList.add('lph-zoekhost');
    form.appendChild(paneel);
    input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', id); input.setAttribute('aria-expanded', 'false'); input.setAttribute('autocomplete', 'off');
    var timer, ctrl, actief = -1, laatste = '';

    function zoekUrl(q) { return actie + '?type=product&q=' + encodeURIComponent(q); }
    function open(html) {
      paneel.innerHTML = html; paneel.hidden = !html;
      form.classList.toggle('is-open', !!html);
      input.setAttribute('aria-expanded', html ? 'true' : 'false');
      actief = -1;
    }
    function sluit() { open(''); }
    function chips(lijst, icoon) { return '<div class="lph-sug__chips">' + lijst.join('') + '</div>'; }
    function startScherm() {
      var r = recent(), h = '';
      if (r.length) {
        h += '<div class="lph-sug__groep"><p class="lph-sug__kop">' + esc(T[5]) + '<button type="button" data-wis>' + esc(T[7]) + '</button></p>' +
          chips(r.map(function (q) { return '<a class="lph-sug__chip lph-sug__nav" href="' + zoekUrl(q) + '" data-q="' + esc(q) + '">' + ic.klok + esc(q) + '</a>'; })) + '</div>';
      }
      if (POP.length) {
        h += '<div class="lph-sug__groep"><p class="lph-sug__kop">' + esc(T[6]) + '</p>' +
          chips(POP.map(function (p) { return '<a class="lph-sug__chip lph-sug__nav" href="' + esc(p.u) + '">' + ic.map + esc(p.t) + '</a>'; })) + '</div>';
      }
      open(h);
    }
    function haal(q) {
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      if (!paneel.hidden) paneel.insertAdjacentHTML('afterbegin', '<div class="lph-sug__laden"></div>');
      var url = URL_SUG + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,tag';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (d) {
        if (q !== input.value.trim()) return;
        var res = (d && d.resources && d.resources.results) || {};
        var LEEG = C.leeg || [];   /* 17-10-2026 LEDPLANET EU: collecties zonder producten in deze markt niet tonen (lijst uit snippets/ledplanet-zoek) */
        var prod = res.products || [], col = (res.collections || []).filter(function (c) { return LEEG.indexOf(c.handle) < 0; }), sug = (res.queries || []).filter(function (s) { return s.text.toLowerCase() !== q.toLowerCase(); });
        var h = '';
        if (sug.length) {
          h += '<div class="lph-sug__groep"><p class="lph-sug__kop">' + esc(T[2]) + '</p>' +
            chips(sug.slice(0, 5).map(function (s) { return '<a class="lph-sug__chip lph-sug__nav" href="' + zoekUrl(s.text) + '" data-q="' + esc(s.text) + '">' + ic.zoek + markeer(s.text, q) + '</a>'; })) + '</div>';
        }
        if (col.length) {
          h += '<div class="lph-sug__groep"><p class="lph-sug__kop">' + esc(T[1]) + '</p>' +
            chips(col.slice(0, 5).map(function (c) { return '<a class="lph-sug__chip lph-sug__nav" href="' + esc(c.url) + '">' + ic.map + markeer(c.title, q) + '</a>'; })) + '</div>';
        }
        if (prod.length) {
          h += '<div class="lph-sug__groep"><p class="lph-sug__kop">' + esc(T[0]) + '</p>' + prod.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
            if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
            var prijs = p.available === false ? '<span class="lph-sug__prijs is-uit">' + esc(T[8]) + '</span>' : '<span class="lph-sug__prijs">' + geld.format(parseFloat(p.price)) + '</span>';
            return '<a class="lph-sug__item lph-sug__nav" href="' + esc(p.url) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="lph-sug__ph"></span>') +
              '<span class="lph-sug__tekst"><span class="lph-sug__titel">' + markeer(p.title, q) + '</span></span>' + prijs + '</a>';
          }).join('') + '</div>';
        }
        if (h) h += '<a class="lph-sug__alle lph-sug__nav" href="' + zoekUrl(q) + '" data-q="' + esc(q) + '"><span>' + esc(T[3]) + ' “' + esc(q) + '”</span>' + ic.pijl + '</a>';
        else h = '<div class="lph-sug__leeg">' + esc(T[4]) + ' “' + esc(q) + '”</div>';
        open(h);
      }).catch(function () {});
    }
    function opInput() {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { laatste = ''; startScherm(); return; }
      if (q === laatste) return;
      timer = setTimeout(function () { laatste = q; haal(q); }, 140);
    }
    // Capture-fase op het formulier: zo komen we vóór de ingebouwde zoekfunctie van het thema en houden die tegen
    form.addEventListener('input', function (e) { if (e.target !== input) return; e.stopPropagation(); opInput(); }, true);
    form.addEventListener('focus', function (e) {
      if (e.target !== input) return; e.stopPropagation();
      if (input.value.trim().length < 2) startScherm(); else { laatste = ''; opInput(); }
    }, true);
    form.addEventListener('keydown', function (e) {
      if (e.target !== input) return;
      var items = paneel.querySelectorAll('.lph-sug__nav');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!items.length) return;
        e.preventDefault(); e.stopPropagation();
        actief = e.key === 'ArrowDown' ? (actief + 1) % items.length : (actief <= 0 ? items.length - 1 : actief - 1);
        items.forEach(function (el, i) { el.classList.toggle('is-actief', i === actief); });
        items[actief].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && actief > -1 && items[actief]) {
        e.preventDefault(); e.stopPropagation(); bewaar(items[actief].dataset.q || input.value); window.location.href = items[actief].href;
      } else if (e.key === 'Escape' && !paneel.hidden) { e.stopPropagation(); sluit(); input.blur(); }
    }, true);
    form.addEventListener('submit', function () { bewaar(input.value); });
    paneel.addEventListener('mousedown', function (e) { e.preventDefault(); });
    paneel.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target.closest('[data-wis]')) { try { localStorage.removeItem('lp_zoek_recent'); } catch (x) {} startScherm(); return; }
      var a = e.target.closest('a'); if (a) bewaar(a.dataset.q || input.value);
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) sluit(); });
    // Eventueel al open ingebouwd resultatenvenster van het thema dichtdoen
    var ps = form.closest('predictive-search');
    if (ps) { ps.removeAttribute('open'); ps.removeAttribute('results'); }
  }

  function zoekVelden() {
    document.querySelectorAll('form[action$="/search"] input[name="q"], form.lph-zoek input[name="q"]').forEach(koppel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', zoekVelden); else zoekVelden();
  // Zoekvelden die later verschijnen (menu op mobiel, zoekvenster) ook koppelen
  var gepland = false;
  new MutationObserver(function () { if (gepland) return; gepland = true; requestAnimationFrame(function () { gepland = false; zoekVelden(); }); }).observe(document.body, { childList: true, subtree: true });
})();
} catch (e) { if (window.console) console.error('lp-site zoek', e); }

/* ===================== uit snippets/ledplanet-beeldzoom ===================== */
try {
  (function () {
    var SEL = '.lpk__beeld img, .main-nav__collection-image img, .lph-cat__img img, .lpc__img img, .lpc__gkop h2 img, .lp-oi img';
    var cache = {};
    // waar staat de tekening in het beeld? (fracties 0-1 van de breedte/hoogte)
    function meet(img) {
      var src = img.currentSrc || img.src;
      if (cache[src] !== undefined) return cache[src];
      var N = 72, c = document.createElement('canvas'); c.width = c.height = N;
      var x = c.getContext('2d', { willReadFrequently: true });
      try {
        x.drawImage(img, 0, 0, N, N);
        var d = x.getImageData(0, 0, N, N).data, a = N, b = N, e = -1, f = -1;
        for (var y = 0; y < N; y++) for (var X = 0; X < N; X++) {
          var k = (y * N + X) * 4, r = d[k], g = d[k + 1], bl = d[k + 2], al = d[k + 3];
          var lum = 0.3 * r + 0.59 * g + 0.11 * bl;
          // lijnen en gele vlakken tellen mee, de zachte gloed en de witte achtergrond niet
          if (al > 60 && (lum < 205 || bl < 140)) { if (X < a) a = X; if (X > e) e = X; if (y < b) b = y; if (y > f) f = y; }
        }
        cache[src] = e < 0 ? null : [a / N, b / N, (e + 1) / N, (f + 1) / N];
      } catch (er) { cache[src] = null; }   // beeld van een ander domein: niet meetbaar, dan niets doen
      return cache[src];
    }
    function zoom(img) {
      if (!img.complete || !img.naturalWidth) return;
      var src = img.currentSrc || img.src;
      if (img.getAttribute('data-lpz') === src) return;
      var m = meet(img);
      img.setAttribute('data-lpz', src);
      if (!m) { img.style.transform = ''; img.style.clipPath = ''; return; }
      // het vakje is vierkant; object-fit: contain -> beeld passend in 1x1
      var nw = img.naturalWidth, nh = img.naturalHeight, s = Math.min(1 / nw, 1 / nh), dw = nw * s, dh = nh * s;
      var ox = (1 - dw) / 2, oy = (1 - dh) / 2;
      var cw = (m[2] - m[0]) * dw, ch = (m[3] - m[1]) * dh;
      var cx = ox + (m[0] + m[2]) / 2 * dw - 0.5, cy = oy + (m[1] + m[3]) / 2 * dh - 0.5;
      var doel = 0.72;   // tekening vult ongeveer 72% van het rondje
      var k = Math.min(doel / Math.max(cw, 0.01), doel / Math.max(ch, 0.01), 3.2);
      // ingezoomd beeld scherp houden: zo nodig een grotere versie van het beeld laden (Shopify-CDN, parameter width)
      var nodig = Math.ceil((img.clientWidth || 60) * Math.max(k, 1) * (window.devicePixelRatio || 1));
      if (nodig > img.naturalWidth * 1.15 && /[?&]width=\d+/.test(src)) {
        var nieuw = src.replace(/([?&]width=)\d+/, '$1' + Math.min(1000, Math.ceil(nodig / 100) * 100));
        if (nieuw !== src) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = nieuw; }
      }
      if (k < 1.08) { img.style.transform = ''; img.style.clipPath = ''; return; }
      img.style.transform = 'scale(' + k.toFixed(3) + ') translate(' + (-cx * 100).toFixed(2) + '%,' + (-cy * 100).toFixed(2) + '%)';
      // na het inzoomen blijft het beeld een rondje van de oorspronkelijke maat (ook waar het vakje zelf niet afsnijdt)
      img.style.clipPath = 'circle(' + (50 / k).toFixed(2) + '% at ' + (50 + cx * 100).toFixed(2) + '% ' + (50 + cy * 100).toFixed(2) + '%)';
    }
    function alles() { document.querySelectorAll(SEL).forEach(zoom); }
    document.addEventListener('load', function (e) { var t = e.target; if (t && t.tagName === 'IMG' && t.matches(SEL)) zoom(t); }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles); else alles();
    window.addEventListener('load', alles);
    // later toegevoegde beelden (megamenu, 'ook te vinden in') worden via hun load-event opgepakt
    setTimeout(alles, 3000);
  })();
} catch (e) { if (window.console) console.error('lp-site beeldzoom', e); }

/* ===================== uit snippets/ledplanet-nachtmodus (teksten: window.LP_NACHT) ===================== */
try {
  (function () {
    var C = window.LP_NACHT || {};
    var UIT = C.uit || 'Lamp uit (nachtmodus)', AAN = C.aan || 'Lamp aan';
    var html = document.documentElement;
    function isNacht() { return html.classList.contains('lp-nacht'); }
    function maak() {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'lp-nacht-knop'; b.setAttribute('role', 'switch');
      b.innerHTML = '<span class="lp-nk__baan" aria-hidden="true"><span class="lp-nk__knop">' +
        '<svg class="lp-nk__lamp" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 0-3.6 10.8c.6.5 1.1 1.3 1.1 2.2h5c0-.9.5-1.7 1.1-2.2A6 6 0 0 0 12 3z" fill="#FFD24A"/></svg>' +
        '<svg class="lp-nk__maan" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z"/></svg>' +
        '</span><span class="lp-nk__ster"></span><span class="lp-nk__ster"></span><span class="lp-nk__ster"></span></span>' +
        '<span class="lp-nk__tip"></span>';
      function zet() {
        var n = isNacht();
        b.setAttribute('aria-checked', n ? 'false' : 'true');   // aan = de lamp brandt
        b.setAttribute('aria-label', n ? AAN : UIT);
        b.querySelector('.lp-nk__tip').textContent = n ? AAN : UIT;
      }
      b.addEventListener('click', function () {
        var dim = document.createElement('div'); dim.className = 'lp-nacht-dim'; document.body.appendChild(dim);
        requestAnimationFrame(function () { dim.classList.add('lp-aan'); });
        setTimeout(function () {
          html.classList.toggle('lp-nacht');
          try { sessionStorage.setItem('lp_nacht', isNacht() ? '1' : '0'); } catch (e) {}
          zet();
          dim.classList.remove('lp-aan');
          setTimeout(function () { dim.remove(); }, 300);
          // op touchscreens de tekst even tonen
          b.classList.add('lp-nk--tip'); setTimeout(function () { b.classList.remove('lp-nk--tip'); }, 1600);
        }, 190);
      });
      zet();
      return b;
    }
    function plaats() {
      var doel = document.querySelector('.header__icons');
      if (!doel || doel.querySelector('.lp-nacht-knop')) return;
      doel.insertBefore(maak(), doel.firstChild);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', plaats); else plaats();
    // de header kan opnieuw opgebouwd worden (bv. in de thema-editor): knop terugzetten
    setTimeout(plaats, 1500);
  })();
} catch (e) { if (window.console) console.error('lp-site nachtmodus', e); }

/* ===================== uit snippets/ledplanet-chatknop (teksten: window.LP_CHAT) ===================== */
try {
  (function () {
    var C = window.LP_CHAT || {};
    var KORT = C.kort || 'Hulp', LANG = C.lang || 'Chat met ons';
    var ICOON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="#fff" aria-hidden="true"><path d="M12 3C6.5 3 2 6.8 2 11.5c0 2.4 1.2 4.6 3.1 6.1L4.3 21l4-1.9c1.1.3 2.4.5 3.7.5 5.5 0 10-3.8 10-8.5S17.5 3 12 3z"/><circle cx="8" cy="11.5" r="1.3" fill="#299AC1"/><circle cx="12" cy="11.5" r="1.3" fill="#299AC1"/><circle cx="16" cy="11.5" r="1.3" fill="#299AC1"/></svg>';
    function roots() {
      var h = document.querySelector('shopify-chat'), uit = [], st = h && h.shadowRoot ? [h.shadowRoot] : [];
      while (st.length) { var r = st.pop(); uit.push(r); r.querySelectorAll('*').forEach(function (e) { if (e.shadowRoot) st.push(e.shadowRoot); }); }
      return uit;
    }
    // de zwevende knop van Shopify Inbox verbergen (het chatvenster zelf blijft gewoon werken)
    function verberg() {
      roots().forEach(function (r) {
        if (!r.__lpVerborgen && r.querySelector('.activator-nudge, section.panel')) {
          var s = document.createElement('style');
          s.textContent = '.activator-nudge{visibility:hidden!important;opacity:0!important;pointer-events:none!important}' +
            // chatvenster in huisstijl: blauwe bovenrand en lichtblauw verloop
            '.panel{background:linear-gradient(180deg,#EAF5F9 0,#F6FBFD 120px,#fff 260px)!important;border:1px solid rgba(41,154,193,.22)!important;border-top:4px solid #299AC1!important;box-shadow:0 30px 70px rgba(18,56,71,.28),0 4px 14px rgba(18,56,71,.08)!important;border-radius:22px!important}';
          r.appendChild(s); r.__lpVerborgen = true;
        }
      });
    }
    function open() {
      // eerder met het kruisje verborgen (oude zwevende knop)? Dan de chat weer toestaan
      try { sessionStorage.removeItem('lp_chat_weg'); } catch (e) {}
      document.documentElement.classList.remove('lp-chat-weg');
      var n = 0;
      (function probeer() {
        var a = null;
        roots().forEach(function (r) { a = a || r.querySelector('.activator'); });
        if (a) { if (a.getAttribute('aria-expanded') !== 'true') a.click(); }
        else if (++n < 16) setTimeout(probeer, 250);   // chat nog aan het laden: even wachten
      })();
    }
    var knop = null;
    function plaats() {
      var doel = document.querySelector('.header__icons');
      if (!doel || doel.querySelector('.lp-chat-knop')) return;
      knop = document.createElement('button');
      knop.type = 'button'; knop.className = 'lp-chat-knop'; knop.setAttribute('aria-label', LANG); knop.title = LANG;
      knop.innerHTML = '<span class="lp-ch__ic">' + ICOON + '<span class="lp-ch__stip"></span></span><span class="lp-ch__tekst">' + KORT + '</span>';
      // pas openen nadat deze klik helemaal klaar is: anders ziet de chat de klik als 'buiten het venster' en sluit hij meteen weer
      knop.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); setTimeout(open, 60); });
      if (!document.querySelector('shopify-chat')) knop.hidden = true;
      var na = doel.querySelector('.lp-nacht-knop');
      doel.insertBefore(knop, na ? na.nextSibling : doel.firstChild);
    }
    function ronde() {
      plaats(); verberg();
      if (knop) knop.hidden = !document.querySelector('shopify-chat');
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ronde); else ronde();
    // eerste 15 s regelmatig kijken (chat laadt later in), daarna alleen nog af en toe (lichter voor de browser)
    (function kijk(n) { ronde(); if (n < 20) setTimeout(function () { kijk(n + 1); }, 750); else setInterval(ronde, 2500); })(0);
  })();
} catch (e) { if (window.console) console.error('lp-site chatknop', e); }

/* ===================== uit snippets/ledplanet-cookies (teksten: window.LP_COOKIES) ===================== */
try {
  (function () {
    var T = window.LP_COOKIES; if (!T) return;
    var LAMP = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#123847" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 0-3.6 10.8c.6.5 1.1 1.3 1.1 2.2h5c0-.9.5-1.7 1.1-2.2A6 6 0 0 0 12 3z" fill="#fff"/><circle cx="10.5" cy="8.5" r=".9" fill="#123847" stroke="none"/><circle cx="13.6" cy="10.2" r=".9" fill="#123847" stroke="none"/><circle cx="11.2" cy="12" r=".8" fill="#123847" stroke="none"/></svg>';
    function pas() {
      var b = document.getElementById('shopify-pc__banner');
      if (!b || b.getAttribute('data-lp') === '1') return;
      var body = b.querySelector('.shopify-pc__banner__body'), h = b.querySelector('#shopify-pc__banner__body-title'), p = body && body.querySelector('p');
      if (!body || !h || !p) return;
      b.setAttribute('data-lp', '1');
      // kop met lampje (een lampje vol 'chocoladestukjes': een koekje dat licht geeft)
      var top = document.createElement('div'); top.className = 'lp-ck-top';
      var ic = document.createElement('span'); ic.className = 'lp-ck-ic'; ic.innerHTML = LAMP;
      h.textContent = T.kop; body.insertBefore(top, h); top.appendChild(ic); top.appendChild(h);
      // tekst, met de bestaande link naar het privacybeleid
      var a = p.querySelector('a');
      p.textContent = T.tekst + ' ';
      if (a) { a.textContent = T.link; p.appendChild(a); p.appendChild(document.createTextNode('.')); }
      var g = document.createElement('p'); g.className = 'lp-ck-groet'; g.textContent = T.groet; body.appendChild(g);
      var ja = b.querySelector('#shopify-pc__banner__btn-accept'), nee = b.querySelector('#shopify-pc__banner__btn-decline'), zelf = b.querySelector('#shopify-pc__banner__btn-manage-prefs');
      if (ja) ja.textContent = T.ja;
      if (nee) nee.textContent = T.nee;
      if (zelf) { var s = zelf.querySelector('span'); (s || zelf).textContent = T.zelf; }
    }
    pas();
    if (window.MutationObserver) {
      var mo = new MutationObserver(pas);
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 20000);
      // later opnieuw tonen (bv. via een link 'cookie-instellingen'): dan weer aanpassen
      document.addEventListener('click', function () { setTimeout(pas, 300); }, true);
    }
  })();
} catch (e) { if (window.console) console.error('lp-site cookies', e); }
